<script>
  import { fade } from 'svelte/transition';
  import Icon from '#lib/Icon.svelte';
  import ButtonLabel from '#lib/ButtonLabel.svelte';

  // IMPORTANT: Currently we don't mutate the value in place, so the parent is handling
  // this in the toggle callback (which should be renamed to ontoggle?).
  let {
    children,
    id,
    name,
    ref = $bindable(),
    class: css_class,
    /** @type {boolean} [value=false] - The current state of the switch */
    value = $bindable(),
    /** @type {Function} - called during onclick event*/
    toggle: toggle_callback,
    /** @type {string|undefined} - name of icon */
    icon = undefined,
    variant = 'brand flush text-compact',
    start_icon,
  } = $props();

  function toggle(event) {
    // console.log('toggle');
    // value = !value;
    event.preventDefault();
    event.stopPropagation();
    toggle_callback && toggle_callback(!value);
  }

</script>

<button
  {id}
  bind:this={ref}
  aria-checked={value}
  role="switch"
  class="switch flex-row justify-between items-center gap-x g-2 {css_class}"
  class:active="{value}"
  onclickcapture={toggle}
>
  <ButtonLabel variant={variant} align='between' {start_icon}>
    {#if children}
      {@render children()}
    {/if}
    {#snippet end_icon()}
      <div class="track-shape">
        <div class="bullet">
          {#if icon}
            <Icon name={icon} color1={value ? 'var(--editing)' : 'var(--color-default-foreground-300)'} size=15 />
          {/if}
        </div>
      </div>
    {/snippet}
  </ButtonLabel>
</button>
<input {name} type='checkbox' bind:checked={value} />


<style lang="postcss">
  .switch {
    --switch-bullet: var(--size-5);
    --switch-padding: var(--size-1);
    --button-label-padding-inline: calc(var(--input-min-height) / 2 * 0.8);
    /* :global(.button-label > *:last-child) {
      padding-inline-end: var(--size-3) !important;
    } */
  }
  .switch:not(.active):hover .track-shape {
    background-color: var(--color-default-background-100);
  }
  .switch.active:hover:not(:focus-visible) .track-shape {
    background-color: var(--editing-200);
  }
  .track-shape {    
    display: flex;
    align-items: center;
    position: relative;
    min-width: calc( var(--switch-bullet) * 2);
    height: calc( var(--switch-bullet) + 2 * var(--switch-padding));
    background-color: var(--color-default-background-200);
    border-radius: var(--round);
    transition: background-color 150ms var(--sharp-deceleration-ease-in);
    will-change: background-color;
  }
  .bullet {
    width: var(--switch-bullet);
    height: var(--switch-bullet);
    border-radius: var(--round);
    background-color: var(--color-default-background);
    z-index: 2;
    position: absolute;
    left: var(--switch-padding);
    transition: left 150ms var(--sharp-deceleration-ease-in);
    will-change: left;
    transform: translate3d();
    display: flex;
    place-content: center;
    place-items: center;
  }

  /* UI States */
  .switch:focus-visible .track-shape {
    outline: 2px solid var(--editing);
    outline-offset: 2px;
  }
  .switch.active .track-shape {
    background-color: var(--editing);
  }
  .switch.active .bullet {
    left: calc( 100% - var(--switch-bullet) - var(--switch-padding))
  }
  input {
    visibility: hidden;
    position: absolute;
    height: 0;
    width: 0;
    appearance: none;
  }
</style>
